export default "__VITE_ASSET__B86Eyl3t__"